<template>
  <div>
    <div class="user">
      <!--      新需求不再支持上传用户头像-->
      <!--      <img class="logo" v-if="userInfo.head" :src="userInfo.head" alt="user logo" />-->
      <img class="logo" src="../images/my-account.png" alt="user logo" />
      <span class="edit" @click="handleEditUserMsg"></span>
      <div class="name-and-eye">
        <p class="name fs-mask" role="user name">{{ realname }}</p>
        <img class="eye" :src="on ? eyeOn : eyeOff" @click="clickEye()" alt="" />
      </div>
      <p class="email fs-mask" role="user email">{{ email }}</p>
      <p class="mobile fs-mask" role="user mobile">{{ showPhone }}</p>
    </div>
    <div class="select">
      <ul>
        <li
          v-for="(item, index) in selectList"
          :key="index"
          @click="handleSelect(item, index)"
          class="select-list"
        >
          <div
            :class="[
              'select-li',
              { 'security-active': showSecurity(item) },
              { 'current-active': currentIndex === index },
            ]"
          >
            <img
              :src="currentIndex === index ? item.changeImgUrl : item.imgUrl"
              alt="select icon"
            />
            <p>{{ $t(item.title) }}</p>
            <span
              v-if="item.key === 'security'"
              :class="['drop-down-icon', iconImg === 'down' ? 'down' : 'up']"
            ></span>
            <span v-if="item.key === 'notify' && hasUnresdMsg" class="unread"></span>
          </div>
          <transition name="fade" v-if="showSubList">
            <ul id="sub-list">
              <li
                v-for="(subItem, subIndex) in item.children"
                :key="subItem.key"
                :class="{ 'current-sub-active': currentSubIndex === subIndex }"
                @click.stop="handleSelect(subItem, subIndex, index)"
              >
                <img :src="subItem.imgUrl" alt="select icon" />
                <p>{{ $t(subItem.title) }}</p>
              </li>
            </ul>
          </transition>
        </li>
      </ul>
    </div>
    <div v-if="showDialog">
      <user-info-dialog-modal-bussiness-component
        :showDialog="showDialog"
        @updateFatherGoToContact="updateGoToContact"
        @updateFather="updateStatus"
        :userInfo="userInfo"
        :dialog-config="dialogConfig"
        @handleOTP="handleOTP"
      />
    </div>
    <div v-if="showCaptcha">
      <dialog-modal
        :showDialogModal="showCaptcha"
        :showCancelBtn="true"
        @show="handleCaptchaShow"
        v-bind="dialogConfig"
        class="code-box-style"
      >
        <template #content>
          <div style="height: 40px"></div>
          <Captcha
            @handleResend="handleResend"
            @handleDone="handleDone"
            @handleFinish="handleFinish"
            :errMsg="errCaptchaMsg"
            :bottomline="false"
          >
            <template #title>
              <img src="~img/icon-lock-black.svg" alt="lock" />
              <span>{{ $i18n.t('code-auth-title') }}</span>
            </template>
            <template #subtitle>{{ $i18n.t('mfa-code-subtitle') }}</template>
            <template #desc>{{ $i18n.t('code-auth-desc1') }}</template>
            <template #info>{{ captchaPhone }}</template>
            <template #other>{{ $i18n.t('mfa-code-info') }}</template>
          </Captcha>
        </template>
      </dialog-modal>
    </div>
  </div>
</template>

<script>
  /* eslint-disable quote-props */
  import store from '@/store';
  import UserInfoDialogModalBussinessComponent from '@/components/UserInfoDialogModalBussinessComponent';
  import DialogModal from '@/components/BaseUi/DialogModal';
  import Captcha from '@/views/Login/Captcha.vue';
  import { mapState } from 'vuex';
  import {
    // decryptAES,
    encryptAES,
    getEmailBeforeAt,
    getFirst4andLast2Num,
    showFirstChar,
  } from '@/utils';

  export default {
    name: 'LeftAccount',

    components: {
      UserInfoDialogModalBussinessComponent,
      DialogModal,
      Captcha,
    },

    props: {
      userData: {
        type: Object,
        default: () => {},
      },
    },

    watch: {
      '$route.name': {
        handler(newVal) {
          // 内部进行切换
          console.log(newVal);
          this.setSelect(newVal);
        },
      },
    },
    computed: {
      ...mapState(['userInfo', 'hasUnresdMsg']),
      // 加密
      changePhone() {
        const { phoneEx, phone } = this.userInfo;
        const phEx = `+${phoneEx}`;
        const newPhone = phone.indexOf(phEx) !== -1 ? phone.slice(phEx.length) : phone;
        return `${phEx} ${getFirst4andLast2Num(newPhone)}`;
      },
      captchaPhone() {
        const { callPrefix, phone } = this.mfaDetail;
        const phEx = `+${callPrefix}`;
        const newPhone = phone.indexOf(phEx) !== -1 ? phone.slice(phEx.length) : phone;
        return `${phEx} ${getFirst4andLast2Num(newPhone)}`;
      },
      showPhone() {
        if (!this.userInfo) return '';
        if (this.on) {
          const { phoneEx, phone } = this.userInfo;
          const phEx = `+${phoneEx}`;
          const newPhone = phone.indexOf(phEx) !== -1 ? phone.slice(phEx.length) : phone;
          return `${phEx} ${newPhone}`;
        }
        return this.changePhone;
      },
    },

    mounted() {
      // 首次从外部跳转进来
      this.setSelect(this.$route.name);
      this.realname = showFirstChar(this.userInfo.realname);
      this.email = getEmailBeforeAt(this.userInfo.email);
      // this.userPhone = this.changePhone
      this.getMFAStatus();
    },

    data() {
      return {
        eyeOn: require('@/assets/images/icon-feather-eye-on.svg'),
        eyeOff: require('@/assets/images/icon-feather-eye-off.svg'),
        on: false,
        realname: '',
        email: '',
        userPhone: '',
        showDialog: false,
        errMessage: [],
        userEditFormValue: {},
        showSubList: false,
        iconImg: 'down',
        currentIndex: '',
        currentSubIndex: '',
        showEditUserMsgModal: false,
        // uploadImgs: '',
        // userUploadFile: {},
        // formData: {},
        // 修改用户信息弹窗有单独的样式，因为业务组件默认为移动端样式
        dialogConfig: {
          PCMaskAndModal: {
            mask: {
              position: 'fix',
            },
            msgModal: {
              position: 'fix',
              // transform: 'translate(-50%, -50%)'
            },
          },
        },
        selectList: [
          {
            imgUrl: require('../images/icon-notification.svg'),
            changeImgUrl: require('../images/icon-notification-w.svg'),
            title: 'mbs-select-notify',
            key: 'notify',
          },
          {
            imgUrl: require('../images/icon-membership.svg'),
            changeImgUrl: require('../images/icon-membership-w-min.svg'),
            title: 'mbs-select-membership',
            key: 'membership',
          },
          {
            imgUrl: require('../images/icon-favourites.svg'),
            changeImgUrl: require('../images/icon-favourites-w-min.svg'),
            title: 'mbs-select-favourites',
            key: 'favourites',
          },
          {
            imgUrl: require('../images/icon-visited-places.svg'),
            changeImgUrl: require('../images/icon-visited-places-w-min.svg'),
            title: 'mbs-select-places',
            key: 'places',
          },
          {
            imgUrl: require('../images/icon-booking-nav.svg'),
            changeImgUrl: require('../images/icon-booking-nav-white.svg'),
            title: 'mbs-select-mytrips',
            key: 'mytrips',
          },
          {
            imgUrl: require('../images/icon-language.svg'),
            changeImgUrl: require('../images/icon-language-w-min.svg'),
            title: 'mbs-select-email',
            key: 'email',
          },
          {
            imgUrl: require('../images/icon-change-password.svg'),
            changeImgUrl: require('../images/icon-change-password-w-min.svg'),
            title: 'mbs-select-security',
            key: 'security',
            children: [
              {
                imgUrl: require('../images/icon-key-min.svg'),
                changeImgUrl: require('../images/icon-key-min.svg'), // 还没有图片
                title: 'mbs-select-change',
                key: 'changekey',
              },
              {
                imgUrl: require('../images/icon-phone-min.svg'),
                changeImgUrl: require('../images/icon-phone-min.svg'), // 还没有图片
                title: 'mbs-select-history',
                key: 'history',
              },
              {
                imgUrl: require('../images/icon-mfa.svg'),
                changeImgUrl: require('../images/icon-mfa.svg'), // 还没有图片
                title: 'mbs-select-mfa',
                key: 'mfa',
              },
            ],
          },
          {
            imgUrl: require('../images/icon-privacy-settings.svg'),
            changeImgUrl: require('../images/icon-privacy-settings-min.svg'),
            title: 'mbs-select-privacysettings',
            key: 'privacysettings',
          },
          {
            imgUrl: require('../images/icon-contact.svg'),
            changeImgUrl: require('../images/icon-contact-min.svg'),
            title: 'mbs-select-Contact',
            key: 'contact',
          },
          {
            imgUrl: require('../images/icon-deletion.svg'),
            changeImgUrl: require('../images/icon-deletion-min.svg'),
            title: 'mbs-select-deletion',
            key: 'deleteaccount',
          },
          // {
          //   imgUrl: require('../images/icon-termsofservice.svg'),
          //   title: this.$i18n.t('mbs-select-service'),
          //   key: 'service',
          // },
          {
            imgUrl: require('../images/icon-logout.svg'),
            title: 'mbs-select-out',
            key: 'logout',
          },
        ],
        showCaptcha: false,
        authKey: '',
        mfaDetail: {},
        errCaptchaMsg: '',
        handleSave: null,
      };
    },

    methods: {
      clickEye() {
        this.on = !this.on;
        if (!this.on) {
          this.realname = showFirstChar(this.userInfo.realname);
          this.email = getEmailBeforeAt(this.userInfo.email);
        } else {
          this.realname = this.userInfo.realname;
          this.email = this.userInfo.email;
        }
      },
      // PC端跳转到contact页面，让showDialog一直为false
      updateGoToContact() {
        this.showDialog = false;
      },
      // PC端保存修改信息成功后，更新用户信息展示
      // updateSuc2(newUserInfo) {
      //   console.log('newUserInfo')
      //   store.commit('setState', {
      //     state: 'userInfo',
      //     values: newUserInfo
      //   })
      // },
      // PC端关闭弹窗后，让showDialog一直为false
      updateStatus() {
        this.showDialog = false;
      },
      // 点击修改按钮，让showDialog一直为true
      handleEditUserMsg() {
        this.showDialog = true;
      },

      // 设置当前选中项
      setSelect(name) {
        const routeName = name.toLowerCase();
        // TODO: 此处后期可以再优化下
        if (routeName === 'changekey' || routeName === 'history' || routeName === 'mfa') {
          this.showSubList = true;
          if (routeName === 'changekey') this.handleSelect({ key: routeName }, 0, 6);
          if (routeName === 'history') this.handleSelect({ key: routeName }, 1, 6);
          if (routeName === 'mfa') this.handleSelect({ key: routeName }, 2, 6);
          return;
        }
        if (routeName === 'tripsdetail') {
          this.handleSelect({ key: routeName }, 4);
          return;
        }
        if (routeName === 'switchmembership' || routeName === 'removemembership') {
          this.handleSelect({ key: routeName }, 1);
          return;
        }
        if (routeName === 'visitedplaces') {
          this.handleSelect({ key: routeName }, 3);
          return;
        }
        const routeNameIndex = this.selectList.findIndex(item => item.key === routeName);
        this.handleSelect({ key: routeName }, routeNameIndex);
      },

      handleSelect(data, index, parentIndex = '') {
        // 父元素选中样式
        if (
          data.key !== 'changekey' &&
          data.key !== 'history' &&
          data.key !== 'mfa' &&
          data.key !== 'logout'
        ) {
          this.currentIndex = index;
          if (this.currentIndex === -1) this.currentIndex = 0;

          // 点击security选项
          if (data.key === 'security') {
            this.showSubList = !this.showSubList;
            this.iconImg = this.iconImg === 'down' ? 'up' : 'down';
            return;
          }

          this.currentSubIndex = '';
          this.showSubList = false;
          this.iconImg = 'down';
        }

        // 子元素选中样式
        if (data.key === 'changekey' || data.key === 'history' || data.key === 'mfa') {
          this.currentIndex = parentIndex;
          this.currentSubIndex = index;
        }

        this.$emit('handleSelect', data);
      },

      showSecurity(item) {
        return this.showSubList && item.title === 'Security';
      },

      getUserInfo() {
        const { userId, sessionId } = this.userInfo;
        const data = {
          userId,
          sessionId,
        };

        this.$http.member
          .getUserInfo(data)
          .then(res => {
            if (res.state === '11') {
              sessionStorage.setItem('user', encryptAES(JSON.stringify(res.userInfo)));
              store.commit('setState', {
                state: 'userInfo',
                values: res.userInfo,
              });
              this.userInfo = res.userInfo;
              this.showMessageBox('success');
            } else {
              console.error(res.note);
            }
          })
          .catch(err => {
            console.error(err);
          });
      },
      getMFAStatus() {
        const { userId, sessionId } = this.userInfo;
        const data = {
          userId,
          lang: this.$i18n.locale,
          sessionId,
        };
        this.$http.account.getMFAStatus(data).then(res => {
          if (res.state === '11') {
            this.mfaDetail = res.payload;
          }
        });
      },
      handleOTP(userEditFormValue, cb) {
        const { phone, exphone } = userEditFormValue;
        this.mfaDetail.phone = phone;
        this.mfaDetail.callPrefix = exphone;
        this.handleSave = cb;
        this.sendAuthCode(() => {
          this.showCaptcha = true;
        });
      },
      handleCaptchaShow(value) {
        this.showCaptcha = value;
      },
      sendAuthCode(successCallback) {
        const { callPrefix, phone, userId } = this.mfaDetail;
        const userContactToken = sessionStorage.getItem('userContactToken');
        const data = {
          userId,
          authType: 2,
          callPrefix,
          phone,
          userContactToken,
          lang: this.$i18n.locale,
          sendScene: 1, // 0 默认普通opt场景    1 修改手机场景
        };
        this.$http.account.sendAuthCode(data).then(res => {
          if (res.state === '11') {
            // code sent
            this.authKey = res.payload.key;
            successCallback && successCallback();
          } else {
            // 错误码处理
            if (res.errorCode === 'retry.after.1.min') {
              this.$messageModal.show({
                image: false,
                closeIcon: true,
                desc: this.$i18n.t('otp-errmsg-desc-4'),
                confirmBtn: this.$i18n.t('ok'),
                justHide: true,
              });
            } else if (res.errorCode === 'changePhone.error.6.locked.30') {
              this.$messageModal.show({
                title: this.$i18n.t('otp-errmsg-title-3'),
                image: false,
                closeIcon: true,
                desc: this.$i18n.t('otp-errmsg-desc-5'),
                confirmBtn: this.$i18n.t('ok'),
                justHide: true,
                successCallback: () => {
                  this.showCaptcha = false;
                },
              });
            } else if (res.errorCode === 'changePhone.too.many.requests') {
              this.$messageModal.show({
                title: this.$i18n.t('otp-errmsg-title-2'),
                image: false,
                closeIcon: true,
                desc: this.$i18n.t('otp-errmsg-desc-2'),
                confirmBtn: this.$i18n.t('ok'),
                justHide: true,
                successCallback: () => {
                  this.showCaptcha = false;
                },
              });
            }
          }
        });
      },
      handleResend() {
        this.sendAuthCode();
      },
      handleFinish(data) {
        console.log('finish', data);
        this.errCaptchaMsg = '';
      },
      handleDone(authCode) {
        console.log('done');
        const { callPrefix, phone, userId } = this.mfaDetail;
        const userContactToken = sessionStorage.getItem('userContactToken');
        const data = {
          userId,
          lang: this.$i18n.locale,
          authType: 2,
          authCode,
          key: this.authKey,
          deviceId: localStorage.getItem('deviceId'),
          callPrefix,
          phone,
          userContactToken,
          checkScene: 1,
        };
        this.$http.account
          .checkAuthCode(data)
          .then(res => {
            if (res.state === '11') {
              // show success
              this.showCaptcha = false;
              this.handleSave();
            } else {
              if (res.errorCode === 'opt.code.error') {
                this.errCaptchaMsg = this.$i18n.t('code-auth-notmatch');
              } else if (res.errorCode === 'changePhone.error.6.locked.30') {
                this.$messageModal.show({
                  title: this.$i18n.t('otp-errmsg-title-1'),
                  image: false,
                  closeIcon: true,
                  desc: this.$i18n.t('otp-errmsg-desc-1'),
                  confirmBtn: this.$i18n.t('ok'),
                  justHide: true,
                  successCallback: () => {
                    this.showCaptcha = false;
                  },
                });
              } else if (res.errorCode === 'auth.error.locked.30') {
                this.$messageModal.show({
                  title: this.$i18n.t('otp-errmsg-title-3'),
                  image: false,
                  closeIcon: true,
                  desc: this.$i18n.t('otp-errmsg-desc-1'),
                  confirmBtn: this.$i18n.t('ok'),
                  justHide: true,
                  successCallback: () => {
                    this.showCaptcha = false;
                  },
                });
              }
            }
          })
          .catch(err => {
            console.log(err);
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
  @use './index';
  @use './mobile';
</style>
